import { inject, Injectable } from '@angular/core';
import { IdentifierGroup, IdentifierGroupStatusChangePayload, IdentifierPool } from './identifier-pools-model';
import { Observable } from 'rxjs';
import { ApiService } from '../../auth-o3/shared/services/api.service';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IdentifierPoolsService {

  private readonly apiService = inject(ApiService);
  private readonly BASE_URL = environment.api.productData;

  public getAllIdentifierPools(): Observable<IdentifierPool[]> {
    return this.apiService.get<IdentifierPool[]>(`identifiers/pools`, this.BASE_URL)
      .pipe(first());
  }

  public getIdentifierPoolById(id: number): Observable<IdentifierPool> {
    return this.apiService.get<IdentifierPool>(`identifiers/pools/byId/${id}`, this.BASE_URL)
      .pipe(first());
  }

  public createIdentifierPool(pool: IdentifierPool): Observable<IdentifierPool> {
    return this.apiService.post<IdentifierPool, IdentifierPool>(`identifiers/store/pools`, pool, this.BASE_URL)
      .pipe(first());
  }

  public updateIdentifierPoolById(pool: IdentifierPool): Observable<IdentifierPool> {
    return this.apiService.patch<IdentifierPool, IdentifierPool>(`identifiers/update/pools/${pool.id}`, pool, this.BASE_URL)
      .pipe(first());
  }

  public deleteIdentifierPoolById(id: number): Observable<any> {
    return this.apiService.delete<any>(`identifiers/delete/pools/${id}`, {}, this.BASE_URL)
      .pipe(first());
  }

  public getAllIdentifierGroups(): Observable<IdentifierGroup[]> {
    return this.apiService.get<IdentifierGroup[]>(`identifiers/groups`, this.BASE_URL)
      .pipe(first());
  }

  public getIdentifierGroupById(id: number): Observable<IdentifierGroup> {
    return this.apiService.get<IdentifierGroup>(`identifiers/groups/${id}`, this.BASE_URL)
      .pipe(first());
  }

  public setIdentifierGroupStatus(id: number, status: IdentifierGroupStatusChangePayload): Observable<IdentifierGroup> {
    return this.apiService
      .patch<IdentifierGroupStatusChangePayload, IdentifierGroup>(`identifiers/groups/${id}/status`, status, this.BASE_URL)
      .pipe(first());
  }

  public deleteIdentifierGroupById(id: number): Observable<any> {
    return this.apiService.delete(`identifiers/delete/groups/${id}`, {}, this.BASE_URL)
      .pipe(first());
  }

  public uploadIdentifierGroupsFile(file: any): Observable<any> {
    return this.apiService.post<any, any>(`identifiers/groups/import`, file, this.BASE_URL)
      .pipe(first());
  }

  public allocateIdentifiers(productId: number): Observable<void> {
    return this.apiService.put<any, void>(`identifiers/allocate`, {productId: Number(productId)}, this.BASE_URL)
      .pipe(first());
  }
}
